import { DrugstoreInterface, PermissionsInterface } from '../../interfaces/drugstore';
import { UserInterface } from '../../interfaces/user';

export interface PermissionsState {
  readonly user: UserInterface;
  readonly current_drugstore?: DrugstoreInterface;
  readonly allowed_drugstores: DrugstoreInterface[];
  readonly error: boolean;
  readonly loading: boolean;
}

export enum ActionTypes {
  FETCH = 'permissions/FETCH',
  FETCH_SUCCESS = 'permissions/FETCH_SUCCESS',
  FETCH_ERROR = 'permissions/FETCH_ERROR',
}

export interface FetchPermissionsAction {
  type: ActionTypes.FETCH;
}

export interface FetchPermissionsSuccessAction {
  type: ActionTypes.FETCH_SUCCESS;
  permissions: PermissionsInterface;
}

export interface FetchPermissionsErrorAction {
  type: ActionTypes.FETCH_ERROR;
}

export type Action = FetchPermissionsAction | FetchPermissionsSuccessAction | FetchPermissionsErrorAction;
